import {
  MoveMoneyPageSectionTile,
  Typenames,
  VxlListItem,
  VxlListItemLeadingAccessoryResult,
} from '@varo/graphql-schema-types';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';

import {
  isVxlIconType,
  isVxlIllustrationType,
  isVxlSectionDivider,
} from './moveMoneyTileTypeGuards';

export const isApplePayRoute = (route?: string): boolean => {
  return !!route?.includes('apple-pay');
};

export const isGooglePayRoute = (route?: string): boolean => {
  return !!route?.includes('google-pay');
};

export const buildLeadingAccessory = (
  listItem: VxlListItem,
  tileId: string,
): VXLComponent | undefined => {
  const accessory: VxlListItemLeadingAccessoryResult | undefined =
    listItem?.leadingAccessory ?? undefined;

  if (!accessory) {
    return undefined;
  }

  // Discriminate VXLIconType vs VXLIllustrationType based on __typename.
  // The GraphQL fragment aliases VXLIconType.key → iconKey,
  // while VXLIllustrationType exposes key directly.
  if (isVxlIconType(accessory)) {
    return {
      id: `${tileId}-icon`,
      name: VXLComponentId.ICON_AVATAR,
      props: {
        iconKey: accessory.key,
        variant: 'LG',
        backgroundColor: 'none',
      },
    };
  }

  if (isVxlIllustrationType(accessory)) {
    return {
      id: `${tileId}-icon`,
      name: VXLComponentId.ICON_AVATAR,
      props: {
        illustrationKey: accessory.key,
        variant: 'LG',
        backgroundColor: 'none',
      },
    };
  }

  return undefined;
};

export const renderSectionHeaderBasedOnLabel = (
  vxlTile: MoveMoneyPageSectionTile,
): VXLComponent | undefined => {
  if (
    vxlTile?.header &&
    '__typename' in vxlTile.header &&
    vxlTile.header.__typename === Typenames.MoveMoneyVxlTile &&
    'content' in vxlTile.header
  ) {
    const headerContent = vxlTile.header.content;

    if (isVxlSectionDivider(headerContent)) {
      const labelText = headerContent.labelText;
      return {
        id: vxlTile.id,
        name: VXLComponentId.SECTION_DIVIDER,
        props: {
          labelText: labelText,
        },
      };
    }
  }
  return undefined;
};
